exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/github-repo-charts/github-repo-charts.component.scss
// module id = ./src/app/components/github-repo-charts/github-repo-charts.component.scss
// module chunks = main